<template>
  <div class="quick-bar">
    <div class="quick-bar-row" ref="rowRef" @pointerdown="onPointerDown">
      <span class="quick-bar-label">快速提问</span>
      <button
        v-for="(item, index) in quickQuestions"
        :key="index"
        class="quick-bar-item"
        :title="item.prompt || item.question"
        @click="$emit('pick', item.prompt || item.question)"
      >
        <span class="qb-text">{{ item.question }}</span>
      </button>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue'
// 快速提问条：紧贴输入框上方的横向快捷问题（数量多则横向滚动，1 条也不显空旷）
defineProps({
  quickQuestions: { type: Array, default: () => [] }
})

defineEmits(['pick'])

// 按住拖动横向滚动：鼠标按住拖动（触屏/触控板走浏览器原生横滑，无需处理）
const rowRef = ref(null)
let dragState = null
function onPointerDown(e) {
  if (e.pointerType !== 'mouse') return
  const el = rowRef.value
  if (!el || el.scrollWidth <= el.clientWidth) return
  dragState = { startX: e.clientX, startLeft: el.scrollLeft, moved: false }
  window.addEventListener('pointermove', onPointerMove)
  window.addEventListener('pointerup', onPointerUp)
}
function onPointerMove(e) {
  if (!dragState) return
  const el = rowRef.value
  const dx = e.clientX - dragState.startX
  if (Math.abs(dx) > 4) dragState.moved = true
  if (dragState.moved) el.scrollLeft = dragState.startLeft - dx
}
function onPointerUp() {
  window.removeEventListener('pointermove', onPointerMove)
  window.removeEventListener('pointerup', onPointerUp)
  if (dragState && dragState.moved) {
    // 拖动结束后抑制本次 click，避免误触发快捷问题
    const suppress = (ev) => {
      ev.stopPropagation()
      ev.preventDefault()
      document.removeEventListener('click', suppress, true)
    }
    document.addEventListener('click', suppress, true)
  }
  dragState = null
}
</script>

<style scoped>
/* 悬浮在输入框上方，不占文档流：有/无快捷问题都不影响中间智能体区位置 */
.quick-bar {
  position: absolute;
  left: 20px;
  right: 20px;
  bottom: 100%;
  z-index: 10;
  padding-bottom: 8px;
}

.quick-bar-row {
  display: flex;
  align-items: center;
  gap: 6px;
  overflow-x: auto;
  padding: 7px 12px;
  background: #fafbfc;
  border: 1px solid #f0f2f5;
  border-radius: 10px;
  user-select: none;
  cursor: grab;
}
.quick-bar-row:active {
  cursor: grabbing;
}
.quick-bar-row::-webkit-scrollbar {
  height: 4px;
}
.quick-bar-row::-webkit-scrollbar-thumb {
  background: #e4e7ed;
  border-radius: 4px;
}
.quick-bar-row::-webkit-scrollbar-thumb:hover {
  background: #d0d7de;
}

.quick-bar-label {
  flex-shrink: 0;
  font-size: 11px;
  color: #a8b0b8;
  margin-right: 2px;
}

.quick-bar-item {
  display: inline-flex;
  align-items: center;
  flex-shrink: 0;
  max-width: 340px;
  height: 26px;
  padding: 0 12px;
  border: 1px solid #e4e7ed;
  border-radius: 999px;
  background: #fff;
  font-size: 12px;
  color: #57606a;
  cursor: pointer;
  white-space: nowrap;
  transition: all 0.15s;
}
.quick-bar-item:hover {
  border-color: #409eff;
  color: #2b7fd4;
  background: #fafcff;
}

.qb-text {
  overflow: hidden;
  text-overflow: ellipsis;
}

@media (max-width: 768px) {
  .quick-bar {
    left: 12px;
    right: 12px;
    padding-bottom: 6px;
  }
  .quick-bar-item {
    max-width: 220px;
  }
}
</style>
